import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import VueApexCharts from "vue3-apexcharts";

const __default__ = {
  components: {
    VueApexCharts,
  },
};
import { UseSegmentComparisonStore } from "../../State/Stores/SegmentComparisonStore";
import { UseChartTemplateHelper } from "../../../Helper/ThirdParty/UseSegmentChartTemplateHelper";
import {
  IGetAllColumns,
  TChartData,
  TAllTableHeaderValues,
} from "../../../../typings/DataFetching";
import { computed, Ref, toRefs } from "vue";
import { storeToRefs } from "pinia";

interface IChartExportData {
  top: TChartData;
  bottom: TChartData;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    channelName: null,
    chartExportData: null,
    bottomName: null,
    topName: null
  },
  setup(__props: any) {

const props = __props as {
  channelName: string;
  chartExportData: IChartExportData;
  bottomName: string;
  topName: string;
}


const { chartExportData, channelName, topName, bottomName } = toRefs(props);

const { getSegmentMetric } = storeToRefs(UseSegmentComparisonStore());

const getChartDataTop = computed(() => chartExportData.value.top);
const getChartDataBottom = computed(() => chartExportData.value.bottom);
const helperProps = {
  name: channelName.value,
  top: getChartDataTop.value,
  bottom: getChartDataBottom.value,
  channelName: channelName.value,
  metric: getSegmentMetric as Ref<keyof TAllTableHeaderValues<IGetAllColumns>>,
  topName: topName.value,
  bottomName: bottomName.value,
};
const { chartOptions, series } = UseChartTemplateHelper(helperProps);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VueApexCharts), {
      ref: 'breakdownChart' + _unref(channelName),
      type: "area",
      options: _unref(chartOptions),
      series: _unref(series),
      height: "250"
    }, null, 8, ["options", "series"])
  ]))
}
}

})